export default "__VITE_ASSET__5g_qmGSf__"